import { render } from "./CartPaymentAlma.vue?vue&type=template&id=18b45a2b"
import script from "./CartPaymentAlma.vue?vue&type=script&lang=js"
export * from "./CartPaymentAlma.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__